import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import { useLanguage } from '../../../Providers/LanguageContext'

function DashboardChartThree({ data, userType }) {
    const { language } = useLanguage()
    // console.log(data, "Dataaababy", Math.round(data[0]), Math.round(data[1]))
    const [series, setSeries] = useState([Math.round(data[0]), Math.round(data[1])])
    console.log("series", series)

    const [options, setOptions] = useState({
        chart: {
            type: 'donut',
        },
        plotOptions: {
            pie: {
                customScale: 1,
                
            }
            
        },
        labels: userType && userType === 'Business'
            ?
            [language.profit_percentage, language.expense_percentage]
            :
            [language.expense_persent_ofIncome, language.expense_parcent_of_budget],
        colors: [
            // function({ value, seriesIndex, w }) {
            //     if (value >=40) {
            //       return '#052d6e'
            //     } else if(value<40 && value>30) {
            //       return '#6c7078'
            //     }else{
            //       return "#8b96ad"
            //     }
            //   },
            //   function({ value, seriesIndex, w }) {
            //     if (value >=40) {
            //       return '#052d6e'
            //     } else if(value<40 && value>30) {
            //       return '#46474a'
            //     }else{
            //       return "#46474a"
            //     }
            //   },
            "#0C2537",
            "#16A34A",
            
        ],
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    height: 150,
                    width: '100%',
                },
                legend: {
                    position: 'bottom'
                }
            }
        }],
        legend: {
            show: true,
            showForSingleSeries: false,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: "bottom",

        }
    }
    )

    useEffect(() => {
        if (data.length > 0) {
            setSeries([Math.round(data[0]), Math.round(data[1])])
        }
    }, [data])

    return (
        <>
            {
                data && data[0] == 0 && data[1] == 0 && (
                    <h5 style={{
                        color:'#fff'
                    }} className='text-center mt-3'>{language.no_data}</h5>
                )
            }
            <ReactApexChart options={options}   width={"100%"} height={300} series={series} type="donut" />

        </>
    )
}

export default DashboardChartThree;